import { DraftField } from "@/components/cadastro/draft-field";
import { CadastroMultiField } from "@/components/cadastro/multi-field";
import { FormSection } from "@/components/ui/form-section";
import { maskPhone } from "@/components/wizard/masks";
import { CadastroLabels } from "@/lib/labels";

export function ContactSection() {
	const labels = CadastroLabels.field;

	return (
		<FormSection title={CadastroLabels.sectionTitle.contact}>
			<div className="flex flex-col gap-5">
				<CadastroMultiField
					name="phones"
					label={labels.phones}
					slot="phone"
					addLabel="Adicionar telefone"
					placeholder="(31) 99000-0000"
					type="tel"
					mask={maskPhone}
				/>

				<CadastroMultiField
					name="emails"
					label={labels.emails}
					slot="email"
					addLabel="Adicionar email"
					placeholder="nome@exemplo.com"
					type="email"
				/>

				<div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
					<DraftField fieldKey="address_raw" span />
					<DraftField fieldKey="address_cep" />
					<DraftField fieldKey="preferred_channel" />
				</div>
			</div>
		</FormSection>
	);
}
